import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from 'components/Ui/Dialog';
import { SuccessBlock } from 'components/Ui';
import { selectDrawerStatus } from 'containers/DrawerManager/selectors';
import { hideDrawer } from 'containers/DrawerManager/actions';
import { UPDATE_ADD_TO_RECURRING_ORDER_SUCCESS } from 'containers/PrimoAccount/constants';

import styles from './styles.scss';

const ChangeSuccessfulModal = ({ message }) => {
  const dispatch = useDispatch();
  const open = useSelector(
    selectDrawerStatus(UPDATE_ADD_TO_RECURRING_ORDER_SUCCESS),
  );

  const handleClose = () =>
    dispatch(hideDrawer(UPDATE_ADD_TO_RECURRING_ORDER_SUCCESS));

  return (
    <Dialog
      size="small"
      open={open}
      onClose={handleClose}
      isCloseIcon={false}
      className={styles.modal}
      isAutoClose
    >
      <SuccessBlock text={message} />
    </Dialog>
  );
};

ChangeSuccessfulModal.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ChangeSuccessfulModal;
